export default __webpack_public_path__ + "static/media/3DPrinting_02.46c024d3.png";